module.exports = __webpack_public_path__ + "static/img/11一种便于调节的凹版印花机.9120e827.jpg";